import { ColumnFilter } from './ColumnFilter.js'

//The framework for table creation for the resource constraints.
export const ColumnNames = [
    {
        Header: 'Billing Frequency',
        id: "Bill Frequency",
        accessor: 'billing_frequency',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },
    {
        Header: 'Billing Type',
        id: "Bill Type",
        accessor: 'billing_type',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },
    {
        Header: 'Fixed Amount',
        id: "Fix Amount",
        accessor: 'fixed_amount',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },
    {
        Header: 'Invoice Effective Date',
        id: "Invoice Effect Date",
        accessor: 'invoice_effective_date',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },
    {
        Header: 'PO Number',
        id: "PO Number",
        accessor: 'po_number',
        Cell: ({value})=>{ if (value === null) {return ''} else{return value} },
        Filter: ColumnFilter,
    },
    {
        Header: "Delete",
        id: 'delete',
        Filter: ColumnFilter,
    }
]